/**
 * Functions to handle the arrow buttons to scroll elements using .overflow-x-scroll
 *
 * Depends on a parent wrapper with a class of '.scroll--wrapper' and a data attribute "data-scroll-by-amount"
 * (e.g. <div class="scroll--wrapper" data-scroll-by-amount="120">).
 *
 * Then inside that wrapper two buttons each with a class of '.button-scroll-left' and '.button-scroll-right, respectively.
 * And finally, the element inside the wrapper that will be scrolling with a class of '.overflow-x-scroll'.
 *
 */

import {
  debounce
} from "../utils/debounce";

function attachScrollingListeners(el) {
  function hideRightArrow() {
    if (!container) return; // Eğer container null ise fonksiyonu erken sonlandır

    let width = 0;
    container.querySelectorAll(":scope > *").forEach(el => {
      let style = el.currentStyle || window.getComputedStyle(el);
      let margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      width += el.getBoundingClientRect().width + margin;
    });

    if (container.getBoundingClientRect().width >= width) {
      scrollRightButton.classList.add('hidden');
      scrollLeftButton.classList.add('hidden');
    } else {
      scrollRightButton.classList.remove('hidden');
    }
  }

  let scrollLeftButton = el.querySelector(".scroll-button-left");
  let scrollRightButton = el.querySelector(".scroll-button-right");
  let container = el.querySelector('[class*="-scroll"]');
  let scrollAmount = el.dataset.scrollByAmount ? el.dataset.scrollByAmount : '100';

  if (scrollLeftButton && scrollRightButton && container) { // Ekstra kontrol ekledik
    scrollLeftButton.addEventListener('click', function () {
      container.scrollBy({
        top: 0,
        left: -scrollAmount,
        behavior: "smooth"
      });
    });
    scrollRightButton.addEventListener('click', function () {
      container.scrollBy({
        top: 0,
        left: scrollAmount,
        behavior: "smooth"
      });
    });
    hideRightArrow();
    window.addEventListener('resize', debounce(hideRightArrow, 200));

    container.addEventListener('scroll', debounce(function (e) {
      if (e.target.scrollLeft === 0) {
        scrollRightButton.classList.remove('hidden');
        scrollLeftButton.classList.add('hidden');
        return;
      }

      let width = 0;
      container.querySelectorAll(":scope > *").forEach(el => {
        let style = el.currentStyle || window.getComputedStyle(el);
        let margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        width += el.getBoundingClientRect().width + margin;
      });
      let maxScroll = Math.floor(Math.floor(width) - container.getBoundingClientRect().width);
      if (e.target.scrollLeft < maxScroll) {
        scrollRightButton.classList.remove('hidden');
        scrollLeftButton.classList.remove('hidden');
      } else {
        scrollLeftButton.classList.remove('hidden');
        scrollRightButton.classList.add('hidden');
      }
    }, 200));
  }
}

let scrollWrappers = document.querySelectorAll('.scroll--wrapper');
scrollWrappers.forEach(el => {
  attachScrollingListeners(el);
});

